module.exports = __webpack_public_path__ + "static/img/组 2846.c83bc71.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2846.png
// module id = mWcC
// module chunks = 0